export default function tagBuilder(datalist = []) {
  // console.log("🚀 ~ file: index.js:2 ~ tagBuilder ~ datalist:", datalist)

  return datalist.map((item) => ({
    "key": item.value,
    "value": item.value,
    "label": item.label
  }));
}
